import { FC } from "react";
import { useKeyboardCommand } from "@hooks/keyboard/useKeyboardCommand";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import {
    ResolvedOrgNavigationShortcut,
    useResolvedOrgNavigationShortcuts,
} from "./useResolvedOrgNavigationShortcuts";
import { useOpenFirmSettings } from "./sideNav/useOpenFirmSettings";

interface OrgShortcutKeyboardBindingProps {
    shortcut: ResolvedOrgNavigationShortcut;
}

const OrgShortcutKeyboardBinding: FC<OrgShortcutKeyboardBindingProps> = ({
    shortcut,
}) => {
    const navigate = useStateAwareNavigate();
    const openFirmSettings = useOpenFirmSettings();

    useKeyboardCommand({
        keys: shortcut.keys,
        callback: () => {
            if (shortcut.action === "settings") {
                openFirmSettings?.();
            } else {
                navigate(shortcut.path);
            }
        },
        options: {
            description: shortcut.description,
            useKey: true,
            enabled: shortcut.isEnabled,
        },
    });

    return null;
};

/** Binds the org nav's `g>{key}` shortcuts, the org counterpart of `NavigationShortcutRegistrar`. */
export const OrgNavigationShortcutRegistrar: FC = () => {
    const shortcuts = useResolvedOrgNavigationShortcuts();

    return (
        <>
            {shortcuts.map((shortcut) => (
                <OrgShortcutKeyboardBinding
                    key={shortcut.id}
                    shortcut={shortcut}
                />
            ))}
        </>
    );
};
